"use client";

import {
  createContext,
  FC,
  PropsWithChildren,
  useContext,
  useMemo,
} from "react";

import { i18n } from "@/libs/i18n";

export type LocaleContext = {
  currentLocale: string;
  currentLang: string;
};

const LocaleContext = createContext<LocaleContext>({
  currentLocale: "",
  currentLang: "",
});

export const LocaleProvider: FC<
  PropsWithChildren<{ value: LocaleContext }>
> = ({ children, value }) => {
  return (
    <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>
  );
};

export const useLocale = (): LocaleContext & typeof i18n => {
  const { defaultLocale, langOverride, locales, territory } = i18n;
  const { currentLocale } = useContext(LocaleContext);
  const currentLang = langOverride || currentLocale;

  return useMemo(
    () => ({
      currentLang,
      currentLocale,
      defaultLocale,
      langOverride,
      locales,
      territory,
    }),
    [
      currentLang,
      currentLocale,
      defaultLocale,
      langOverride,
      locales,
      territory,
    ]
  );
};
